import * as S from './styles';

const EmptyPage = ({message}) => {
  return (
    <S.EmptyPage>
      <S.Message>{message || 'Nenhum resultado encontrado'}</S.Message>
      <S.Image src="/assets/images/cart-empty.svg" alt="Ilustração" />
    </S.EmptyPage>
  );
}

export default EmptyPage